import { EducationLevelEnum } from './EducationModels';

export interface UserEducationHistoryModel {
  id: string;
  country: string | null;
  school_name: string | null;
  education_name: string | null;
  education_level: EducationLevelEnum;
  start_date: string | null;
  end_date: string | null;
  is_current: boolean;
  order: number;
}

export interface EditUserEducationHistoryListModel {
  items: UserEducationHistoryModel[] | null;
}
